import PropTypes from 'prop-types';
import React, { Component } from 'react';
import shallowEqual from 'fbjs/lib/shallowEqual';

export default class BareElement extends Component {
  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  getPosition() {
    const { layout } = this.props;
    return {
      position: 'absolute',
      top: layout.y,
      left: layout.x
    };
  }

  getSize() {
    const { layout } = this.props;
    return {
      boxSizing: 'border-box',
      WebkitBoxSizing: 'border-box',
      height: layout.height,
      width: layout.width
    };
  }

  getCompProps() {
    const position = this.getPosition();
    const size = this.getSize();
    const compProps = this.props.compProps;
    return {
      ...position,
      ...size,
      ...compProps
    };
  }

  render() {
    const { type } = this.props;

    return (
      <div style={this.getCompProps()} data-element-type={type}></div>
    );
  }
}

BareElement.propTypes = {
  id: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
    height: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired])
  })
};